var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1563 13.0285C25.1563 19.0697 20.7239 24.0781 14.9378 24.9869V16.5509H17.7512L18.2868 13.0607H14.9378V10.7961C14.9378 9.84087 15.4059 8.91082 16.9049 8.91082H18.427V5.93911C18.427 5.93911 17.0451 5.70306 15.7247 5.70306C12.9668 5.70306 11.1652 7.37453 11.1652 10.3997V13.0597H8.09968V16.5499H11.1652V24.9859C5.38014 24.0761 0.946777 19.0687 0.946777 13.0285C0.946777 6.34361 6.36668 0.923706 13.0515 0.923706C19.7364 0.923706 25.1563 6.3426 25.1563 13.0285Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbWhite);
export default __webpack_public_path__ + "static/media/fb_white.7cfa9da189f371a948f4074dde39985d.svg";
export { ForwardRef as ReactComponent };